import {APP_BASE_HREF} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from "../environments/environment";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public translate: TranslateService, @Inject(APP_BASE_HREF) public baseHref: string) {
    console.log(baseHref);
    const re = new RegExp('/', 'g');
    const href = baseHref.replace(re, '');
    if (href.length > 0) {
      environment.baseHref = href
      environment.enabledBaseHref = true;
      environment.serverUrl = window.location.origin + '/' + href + '/v1/api';
    }
    console.log(environment.serverUrl);
  }

}

